// extracted by mini-css-extract-plugin
export default {"basicInput":"BasicInput_basicInput__NiKmV"};